/* USER */
export const USER_LIST = 'USER_LIST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAILED = 'USER_LIST_FAILED';

export const USER_ADD = 'USER_ADD';
export const USER_ADD_SUCCESS = 'USER_ADD_SUCCESS';
export const USER_ADD_FAILED = 'USERADD_ADD_FAILED';


export const USER_UPDATE = 'USER_UPDATE';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAILED = 'USER_UPDATE_FAILED';

export const USER_DELETE = 'USER_DELETE';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_FAILED = 'USERADD_DELETE_FAILED';


export const IMG_ADD = "IMG_ADD";
export const IMG_ADD_SUCCESS = "IMG_ADD_SUCCESS";
export const IMG_ADD_FAILED = "IMG_ADD_FAILED";
